// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8df73451","453":"194411ee","455":"1386f099","977":"4d6e3f95"}[chunkId] + ".chunk.js";
};